import { render, staticRenderFns } from "./TipTapMenuBar.vue?vue&type=template&id=482a4128&scoped=true&"
import script from "./TipTapMenuBar.vue?vue&type=script&lang=js&"
export * from "./TipTapMenuBar.vue?vue&type=script&lang=js&"
import style0 from "./TipTapMenuBar.vue?vue&type=style&index=0&id=482a4128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a4128",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemTitle,VMenu})
